export class TdoDropdownChange {
  isMultiSelect: boolean = false;
  value: any;
  isAll: boolean = false;
  isUserInput: boolean = true;
}
